import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Subscription, Subject } from "rxjs";
import { tap } from "rxjs/operators";

import { Organization } from "../../../../common/models/organization.model";
import { Dialog, DialogButton } from "../../../../core/models/dialog.model";
import { DynamicDialogService } from "../../../../core/services/dynamic-dialog.service";
import { EDiscoveryService } from "../../../services/eDiscovery.service";
import { OrganizationService } from "../../../../common/services/organization.service";
import { deepClone } from "../../../../builder/models/editor.model";
import { eDiscoveryRequestMode, eDiscoveryRequest, eDiscoveryRequestSearchSpec, eDiscoveryStatusSearchType } from "../../../models/eDiscovery.model";

@Component({
    selector: 'eDiscovery-request-wrapper',
    templateUrl: './request-wrapper.component.html',
    styleUrls: ['./request-wrapper.component.scss'],
    providers: [EDiscoveryService, OrganizationService],
    standalone: false
})
export class EDiscoveryRequestWrapperComponent implements OnInit, OnDestroy {

    allOrganizations: Organization[] = [];

    availableOrgs$: Subscription;
    availableOrganizations: Organization[] = [];
    currentMode: eDiscoveryRequestMode = eDiscoveryRequestMode.Search;

    dummyOrg: Organization = {
        id: "",
        name: "--Select an Organization--"
    } as Organization;


    loadErrorDialog: Dialog = new Dialog("An error as occurred in loading.", [new DialogButton("Cancel", false, () => this.onDialogClose())]);
    modes = eDiscoveryRequestMode;
    newRequest: eDiscoveryRequest;
    notImplementedDialog: Dialog = new Dialog("This function has not yet been implemented.", [new DialogButton("Sorry!", true, () => this.onDialogClose())]);
    organization: Organization = null;   

    searchRequest: eDiscoveryRequestSearchSpec = new eDiscoveryRequestSearchSpec(eDiscoveryStatusSearchType.All, "");
    showSearchResults: boolean = false;
    subscriptions = new Subscription();
    



    constructor(private _route: ActivatedRoute,
        private _organizationService: OrganizationService,
        private _dialogService: DynamicDialogService) { }

    ngOnDestroy() {
        if (this.availableOrgs$) this.availableOrgs$.unsubscribe();
        this.subscriptions.unsubscribe();
    }

    ngOnInit() {
        if (this._route.snapshot.data.organization) {
            this.organization = this._route.snapshot.data.organization;
            this.searchRequest.organizationId = this.organization.id;
        }
        
        this.availableOrgs$ = this._organizationService.getAll().pipe(
            tap((data: Organization[]) => {
                this.allOrganizations = data.sort((a, b) => {
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                    return 0;
                });
            })
        ).subscribe(() => { },
            (error) => {
                console.error(error);
                this.showError(error);
            });
        this.subscriptions.add(this.availableOrgs$);
    }

    cancelNew(): void {
        this.currentMode = eDiscoveryRequestMode.Search;
        let orgId = this.organization ? this.organization.id : "";
        this.searchRequest = new eDiscoveryRequestSearchSpec(eDiscoveryStatusSearchType.All, orgId);
    }

    notImplemented(): void {
        this.notImplementedDialog.toggleDialog(true);
        this._dialogService.updateDialog(this.notImplementedDialog);
    }

    onDialogClose(): void {

    }

    onRequestCancelled(request: eDiscoveryRequest): void {
        this.newRequest = request;
        this.currentMode = eDiscoveryRequestMode.Search;
        const orgId = this.organization ? this.organization.id : "";
        this.searchRequest = new eDiscoveryRequestSearchSpec(eDiscoveryStatusSearchType.All, orgId);
    }

    organizationChanged(newOrg: Organization) {
        this.organization = newOrg;
    }

    paramsChanged(spec: eDiscoveryRequestSearchSpec): void {
        this.showSearchResults = false;        
        this.searchRequest = spec;
    }

    runSearch(request: eDiscoveryRequestSearchSpec): void {  
        this.showSearchResults = false;
        this.organization = this.availableOrganizations.find(o => o.id === request.organizationId);
        this.searchRequest = request;
        this.showSearchResults = true;
    }

    showError(error: any): void {
        this.loadErrorDialog.toggleDialog(true);
        this._dialogService.updateDialog(this.loadErrorDialog);
    }

    startNew(orgToUse: Organization | null): void {     
        if (orgToUse) {
            this.organization = orgToUse;
            let id = this.organization.id
            this.newRequest = { organizationId: id } as eDiscoveryRequest;
        } else {
            this.organization = null;
            this.newRequest = {} as eDiscoveryRequest;
        }
        this.currentMode = eDiscoveryRequestMode.Create;
    }
}
